import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../../../app.constants';

@Injectable({
  providedIn: 'root'
})
export class ShortageOverviewService {
  private overviewUrl = `${AppConstants.API_ENDPOINT}${AppConstants.API.SHORTAGE.SHORTAGE_OVERVIEW}`;
  private analyticsUrl = `${AppConstants.API_ENDPOINT}${AppConstants.API.SHORTAGE.SHORTAGE_ANALYTICS}`;

  constructor(private http: HttpClient) { }

  getOverviewData(email: string, mode: string): Observable<any> {
    return this.http.get(`${this.overviewUrl}?user_email=${email}&view_type=${mode}`);
  }

  getAnalyticsData(email: string, mode: string): Observable<any> {
    return this.http.get(`${this.analyticsUrl}?user_email=${email}&view_type=${mode}`);
  }

  getShortageRecordsByIds(payload: any): Observable<any> {
    const url = `${AppConstants.API_ENDPOINT}${AppConstants.API.SHORTAGE.SHORTAGE_RECORDS}`;
    return this.http.post(url, payload);
  }
}
